export const ROUTE_TO_PAGENAME: Record<string, string> = {
  '/verification-summary/[id]': 'Verification summary viewed',
  '/trademark-academy/article/[slug]': 'Trademark academy article viewed',
}
